<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Minus_Circle"
      data-name="Icon/Minus Circle"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="14.376"
      viewBox="0 0 14.376 14.376"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Minus-circle"
        data-name="Icon/Icon/Minus-circle"
        d="M7.188,14.376a7.188,7.188,0,1,1,7.187-7.187A7.2,7.2,0,0,1,7.188,14.376Zm0-12.938a5.751,5.751,0,1,0,5.75,5.751A5.758,5.758,0,0,0,7.188,1.437ZM9.345,7.906H5.032a.719.719,0,1,1,0-1.437H9.345a.719.719,0,0,1,0,1.437Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MinusCircleIcon extends Vue {}
</script>

<style>
</style>
